export const ADMIN_API_CATEGORIES_URL = '/admin/categories/';
export const ADMIN_API_CATEGORIES_KEY = 'admin_categories_select';
export const ADMIN_API_CATEGORIES_LIST_KEY = 'admin_categories_list';

export const ADMIN_API_SECTORS_URL = '/admin/sectors/';
export const ADMIN_API_SECTORS_KEY = 'admin_sectors_select';
export const ADMIN_API_SECTORS_LIST_KEY = 'admin_sectors_list';

export const ADMIN_API_AI_TAGS_URL = '/admin/tags/';
export const ADMIN_API_AI_TAGS_KEY = 'admin_ai_tags_select';
export const ADMIN_API_AI_TAGS_LIST_KEY = 'admin_ai_tags_list';
export const getAdminAiTagRegenerateBodyUrl = (id: number | string) =>
  `${ADMIN_API_AI_TAGS_URL}${id}/regenerate-body/`;
export const ADMIN_API_AI_TAG_MATERIALS_KEY = 'admin_ai_tag_materials_list';
export const getAdminAiTagMaterialsUrl = (id: number | string) =>
  `${ADMIN_API_AI_TAGS_URL}${id}/materials/`;
export const getAdminAiTagUpdateMaterialSummaryUrl = (id: number | string) =>
  `${ADMIN_API_AI_TAGS_URL}${id}/update-material-summary/`;
export const getAdminMaterialGenerateAiTagsUrl = (id: number | string) =>
  `/admin/materials/${id}/generate-ai-tags/`;
